import React, { Suspense, lazy, useState, useCallback, useEffect } from "react";
import Helmet from "react-helmet";
import Link from "./LinkWithTransitionLock";
import svgPanZoom from "svg-pan-zoom";
import Hammer from "hammerjs";
import { isMobile } from "mobile-device-detect";
import {
  TimelineMax,
  TweenMax,
  TweenLite,
  Linear,
  TextPlugin,
  ThrowPropsPlugin,
  EasePack,
  CSSPlugin,
  ScrollToPlugin,
  Power1,
  Power2,
  Power3,
  Power4,
  Expo,
  gsap,
} from "gsap";

class Page extends React.Component {
  constructor(props) {
    super(props);
  }

  // static contextType = VideoIsPlayedContext;

  componentDidMount() {}

  componentWillUnmount() {}

  render() {
    const items = new Array(5).fill(null);
    return (
      <>
        <section className="concept section_container sticky">
          <div className="inner_content">
            <div className="row_area_m">
              <div className="col_1">
                <div className="col_box col_sticky">
                  <h3 className="section_main_title">
                    認識國家人權博物館
                    <br />
                    <div className="en">National Human Rights Museum</div>
                  </h3>
                </div>
              </div>
              <div className="col_2">
                <article className="inner_article">
                  <p>
                    成立國家人權博物館，是臺灣社會，特別是所有政治受難者前輩長達15年的殷切期待。用國家高度促進當代社會面對人權受害的歷史，反省過去、記取教訓、展望未來。
                  </p>
                  <p>
                    2017年12月13日總統府公布「國家人權博物館組織法」，歷經近6年籌備的國家人權博物館於2018年正式成立，並於同年5月17日、18日分別於「白色恐怖綠島紀念園區」、「白色恐怖景美紀念園區」隆重揭牌。
                  </p>
                  <p>
                    國家人權博物館除持續推動威權統治時期相關人權檔案史料文物的典藏、研究、展示、教育推廣及國際交流工作外，亦將擴大支持各種人權議題及當代人權理念實踐推廣的組織發展，展現臺灣追求落實民主人權普世價值的決心。
                  </p>
                  <p>
                    國家人權博物館編制，除了博物館核心任務的展示、教育、公共服務，特別將景美、綠島二處不義遺址正名為「白色恐怖紀念園區」管理中心，並成立「典藏研究暨檔案中心」，強化史料典藏應用。人權館除了管理景美和綠島兩處園區，亦將擴大連結協助當代人權理念實踐推廣的組織發展與國際交流，彰顯民主、自由、公義的核心價值。
                  </p>
                  <h4>Academic Collection and Audio-Visual Services</h4>
                  <p>
                    National Human Rights Museum has a comprehensive collection
                    of White Terror-related books, archives, research results
                    and oral history AV records along with Human Rights
                    Education Center and several reading rooms. The museum also
                    organizes human rights related speeches and workshops.
                  </p>
                  <h4>Be in The Scene and See for Yourself</h4>
                  <p>
                    With help of interactive films, miniatures, and regular and
                    special exhibitions, one can experience and witness
                    political prisoners’ lives during the White Terror period in
                    the original buildings. Free audio guides are available at
                    the Tourist Service Center.
                  </p>
                  <h4>
                    Real-Person Library Political Prisoners as Your Guides
                  </h4>
                  <p>
                    Former political prisoners are invited to guide tourists
                    through the scenes from those years. You can make a
                    reservation to experience the real person accounts.
                  </p>
                  <h4>Our Mission Are</h4>
                  <ul>
                    <li>
                      Reflections on the Past: Learn the history of human rights
                      violations.
                    </li>
                    <li>
                      Lesson Learned: Never repeat Human rights violations and
                      freedom deprivation.
                    </li>
                    <li>
                      Looking Ahead: Support human rights issues, promote human
                      rights ideals, and realize universal values to safeguard
                      democracy and human rights.
                    </li>
                  </ul>
                </article>
                <div className="link_row">
                  <a
                    href="https://www.nhrm.gov.tw/"
                    className="link_btn"
                    target="_blank"
                  >
                    <div className="btn_text">國家人權博物館 ↗</div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="concept section_container sticky">
          <div className="inner_content">
            <div className="row_area_m">
              <div className="col_1">
                <div className="col_box col_sticky">
                  <h3 className="section_main_title">
                    白色恐怖綠島紀念園區
                    <br />
                    <div className="en">
                      Green Island White Terror Memorial Park
                    </div>
                  </h3>
                </div>
              </div>
              <div className="col_2">
                <article className="inner_article">
                  <p>
                    文化部於2011年成立國家人權博物館籌備處，下轄景美與綠島二處人權文化園區，積極進行白色恐怖相關調查研究、展示、人權教育推廣等工作；2018年3月15日「國家人權博物館」正式成立，二處園區也分別更名為「白色恐怖景美紀念園區」及「白色恐怖綠島紀念園區」。
                  </p>
                  <p>
                    「白色恐怖綠島紀念園區」原為「綠島人權文化園區」，現址為台東縣綠島鄉公館村將軍岩20號，土地面積約32公頃，位於綠島東北角。園區內歷經火燒島浮浪者收容所、新生訓導處、綠洲山莊等不同時期的監獄文化，為威權政府實施重大人權侵害發生地。整個園區的建築群、自然、生態景觀表現長期人群與自然互動的過程，將各種型態的文化資產及地景結合成一文化景觀。
                  </p>
                  <p>
                    戒嚴時期「白色恐怖綠島紀念園區」為軍事、政治、治安案件之羈押的場所；1951年至1970年間之新生訓導處時期，1972年至1987年間之綠洲山莊時期（國防部感訓監獄時期），其中綠洲山莊乃因應1970年泰源事件而興建之高牆封閉式監獄，與新生訓導處時期之空間型態差異大。「白色恐怖綠島紀念園區」在台灣人民爭取人權發展的歷史中，具有特殊意義。
                  </p>
                  <p>
                    The 32-hectare plot in the northeast corner of the Green
                    Island, isolated on the sea, was Vagrants Shelter during
                    Japanese colonial rule; and it became a major prison in the
                    White Terror period immediately after the ROC government
                    moved to Taiwan in 1949. New Life Correction Center and
                    Oasis Villa were set to confine political prisoners. When
                    martial law was lifted, it was became Green Island Prison
                    under the Ministry of Justice and then the military’s moral
                    training center for offenders.
                  </p>
                  <p>
                    Green Island White Terror Memorial Park used to be a prison
                    for political prisoners. This past makes it a “negative
                    tourism” site that induces reflection on human values.
                    Visiting this park, people from home and abroad enjoy its
                    natural setting, but witness Taiwan’s hard road to democracy
                    as well.
                  </p>
                </article>
              </div>
            </div>
          </div>
        </section>

        <Helmet
          title="作品與藝術家・假如綠島是一面鏡子 Through the Reflection of GREEN ISLAND・2021 綠島人權藝術季 Green Island Art Festival"
          meta={[
            {
              name: `description`,
              content:
                "作品與藝術家・假如綠島是一面鏡子 Through the Reflection of GREEN ISLAND・2021 綠島人權藝術季 Green Island Art Festival",
            },
            {
              property: `og:title`,
              content:
                "作品與藝術家・假如綠島是一面鏡子 Through the Reflection of GREEN ISLAND・2021 綠島人權藝術季 Green Island Art Festival",
            },
            {
              property: `og:description`,
              content:
                "作品與藝術家・假如綠島是一面鏡子 Through the Reflection of GREEN ISLAND・2021 綠島人權藝術季 Green Island Art Festival",
            },
            {
              property: `og:type`,
              content: `website`,
            },
            {
              property: `og:image`,
              content: require("../images/og_image.jpg"),
            },
          ]}
        ></Helmet>
      </>
    );
  }
}

export default Page;
